import { SET_ALGOLIA_SEARCH_KEY } from './types';

export const setAlgoliaSearchKey = searchKey => ({
  type: SET_ALGOLIA_SEARCH_KEY,
  payload: searchKey,
});

export default setAlgoliaSearchKey;
